import { FilterInfoRow } from "@faire/retailer-visitor-shared/components/Filters/FilterInfoRow";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageShouldShowEscapeHatchText } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/__internal__/useSearchPageShouldShowEscapeHatchText";
import { MaybeSearchPageSpellCheckSubheader } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/MaybeSearchPageSpellCheckSubHeader";
import { SearchPageSearchResultsText } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/SearchPageSearchResultsText";
import { useSearchPageShouldShowBrandSearch } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageShouldShowBrandSearch";
import { useSearchPageFormattedTotalPrimaryResultsCount } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFormattedTotalPrimaryResultsCount";
import { useSearchPageBrandsOffFaireQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageBrandsOffFaireQuery";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ResultInfoRow } from "@faire/retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchStyles";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

export const SearchPageHeaderSearchResults = ({
  filterRef,
}: {
  filterRef?: React.RefObject<HTMLDivElement | null>;
}) => {
  const shouldShowBrandSearch = useSearchPageShouldShowBrandSearch();
  const brandsOffFaireQuery = useSearchPageBrandsOffFaireQuery();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { isMobile } = useViewport();
  const totalPrimaryResultsFormatted =
    useSearchPageFormattedTotalPrimaryResultsCount();
  const shouldShowEscapeHatchText = useSearchPageShouldShowEscapeHatchText();
  const loading = useSearchPageQueryIsLoading();
  const isSSR = useIsSSR();

  // logged out with new brand search should not show results info row
  // logged in with new brand search should show results info row
  const shouldShowInfoRow =
    shouldShowEscapeHatchText ||
    (!isLoggedInRetailer && !shouldShowBrandSearch) ||
    (isLoggedInRetailer && shouldShowBrandSearch) ||
    brandsOffFaireQuery;

  const isFilterInfoRowShow =
    shouldShowInfoRow && !isMobile && isLoggedInRetailer;

  return (
    <>
      {!isLoggedInRetailer ? <Spacer height={4} /> : null}
      <ResultInfoRow
        ref={isFilterInfoRowShow || !isLoggedInRetailer ? undefined : filterRef}
      >
        {shouldShowBrandSearch && isLoggedInRetailer ? (
          <SpacerForBrandSearch isLoggedInRetailer />
        ) : null}
      </ResultInfoRow>
      {shouldShowInfoRow ? (
        <>
          <ResultInfoRow>
            {isSSR ? (
              <Spacer height="2x" />
            ) : (
              <Column>
                <SearchPageSearchResultsText />
              </Column>
            )}
            {/* logged in search page
                      filter redesign filter info row */}
            {!isMobile && isLoggedInRetailer ? (
              <StyledFilterInfoRow
                name={FilterName.SEARCH}
                resultsCount={isMobile ? "" : totalPrimaryResultsFormatted}
                isLoading={loading}
                divRef={filterRef}
                shouldShowTightenedFilters
                disableHideShow={false}
              />
            ) : null}
          </ResultInfoRow>
        </>
      ) : null}
      {!brandsOffFaireQuery ? <MaybeSearchPageSpellCheckSubheader /> : null}
    </>
  );
};

const SpacerForBrandSearch = ({
  isLoggedInRetailer,
}: {
  isLoggedInRetailer: boolean;
}) => {
  return isLoggedInRetailer ? <Spacer height="5x" /> : <Spacer height="4x" />;
};

const StyledFilterInfoRow = styled(FilterInfoRow)`
  ${responsiveMediaQueries.tabletAndBelow} {
    margin-right: ${getSpacing("2x")};
  }
`;
